import { render, staticRenderFns } from "./popup-color.vue?vue&type=template&id=1e4c22cf&"
import script from "./popup-color.vue?vue&type=script&lang=js&"
export * from "./popup-color.vue?vue&type=script&lang=js&"
import style0 from "./popup-color.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports